import { countryListOptions, countryListOptionWithBedoon } from "./methods";

export const initialFormData = {

  firstName: { value: "", error: "" },
  middleName: { value: "", error: "" },
  lastName: { value: "", error: "" },
  arabicFirstName: { value: "", error: "" },
  arabicMiddleName: { value: "", error: "" },
  arabicLastName: { value: "", error: "" },
  dob: { value: null, error: "" },
  gender: {
    value: "",
    option: [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" }
    ],
    error: ""
  },
  maritalStatus: {
    value: "",
    option: [
      { value: "single", label: "Single" },
      { value: "married", label: "Married" },
      { value: "divorcee", label: "Divorcee" }
    ],
    error: ""
  },
  civilId: { value: "", error: "" },
  civilIdExpiryDate: { value: null, error: "" },
  mobileOne: { value: "", error: "", phoneCode: { value: "" } },
  mobileTwo: { value: "", error: "", phoneCode: { value: "" } },
  homeTelOne: { value: "", error: "", phoneCode: { value: "" } },
  homeTelTwo: { value: "", error: "", phoneCode: { value: "" } },
  workTel: { value: "", error: "", phoneCode: { value: "" } },
  faxTel: { value: "", error: "", phoneCode: { value: "" } },
  emailOne: { value: "", error: "" },
  emailTwo: { value: "", error: "" },
  nationality: { value: "Kuwait", error: "", option: countryListOptions },
  birthCountry: { value: "", error: "", option: countryListOptions },
  passport: { value: null, error: "" },
  passportExpiry: { value: null, error: "" },
  securityCard: { value: null, error: "" },
  validityOfRes: { value: null, error: "" },
  securityCardExpiry: { value: null, error: "" },
  isHealthRecord: { value: null, error: "" },
  healthNote: { value: "", error: "" },
  isSuspended: { value: null, error: "" },
  suspensionNote: { value: "", error: "" },
  sponsorship: {
    value: null,
    error: ""
  },
  sponsorshipOtherNote: {
    value: "",
    error: ""
  },
  sponsorshipScholarshipNote: {
    value: "",
    error: ""
  },

  isDeclared: { value: false, error: "" },
  document: {
    photograph: { value: null, error: "" },
    transcript: { value: null, error: "" },
    englishscore: { value: null, error: "" },
    highschool: { value: null, error: "" },
    civilidFront: { value: null, error: "" },
    civilidBack: { value: null, error: "" },
    securityCardFront: { value: null, error: "" },
    securityCardBack: { value: null, error: "" },
    passport: { value: null, error: "" },
    record: { value: null, error: "" },
    goodconduct: { value: null, error: "" },
    fatherCivilId: { value: null, error: "" },
    motherCivilId: { value: null, error: "" },
    sahel: { value: null, error: "" },
    equivalency: { value: null, error: "" },
    birthCertificate: { value: null, error: "" },
    fatherPassport: { value: null, error: "" },
    motherPassport: { value: null, error: "" },
    otherDocuments: { value: null, error: "" }
  },
  isAcademic: { value: null },
  archivements: { value: [{ value: "", error: "" }] },
  address: {
    home: { value: "", error: "" },
    block: { value: null, error: "" },
    appartment: { value: null, error: "" },
    street: { value: "", error: "" },
    area: { value: "", error: "" },
    jaddah: {
      value: null,
      option: [
        { value: true, label: "True" },
        { value: false, label: "False" }
      ],
      error: ""
    },
    countryWithBedoon: {
      value: "",
      error: "",
      option: countryListOptionWithBedoon
    },
    country: { value: "", error: "", option: countryListOptions },
    po: { value: null, error: "" },
    zipCode: { value: null, error: "" },
    governorate: {
      value: "",
      option: [
        { value: "Ahmadi Governorate", label: "Ahmadi Governorate" },
        { value: "Al-Asimah Governorate", label: "Al-Asimah Governorate" },
        { value: "Farwaniya Governorate", label: "Farwaniya Governorate" },
        { value: "Hawalli Governorate", label: "Hawalli Governorate" },
        { value: "Jahra Governorate", label: "Jahra Governorate" },
        {
          value: "Mubarak Al-Kabeer Governorate",
          label: "Mubarak Al-Kabeer Governorate"
        }
      ],
      error: ""
    }
  },
  family: {
    fatherName: { value: "", error: "" },
    arabicFatherName: { value: "", error: "" },
    fatherDob: { value: null, error: "" },
    fatherNationality: { value: "", error: "", option: countryListOptions },
    fatherCivilId: { value: null, error: "" },
    fatherOccup: { value: "", error: "" },
    fatherEmployer: { value: "", error: "" },
    fatherDepartment: { value: "", error: "" },
    fatherMobile: { value: null, error: "", phoneCode: { value: "" } },
    fatherWorkTel: { value: null, error: "", phoneCode: { value: "" } },
    fatherEmail: { value: "", error: "" },
    fatherExactJob: { value: "", error: "" },
    motherName: { value: "", error: "" },
    arabicMotherName: { value: "", error: "" },
    motherDob: { value: null, error: "" },
    motherNationality: { value: "", error: "", option: countryListOptions },
    motherCivilId: { value: "", error: "" },
    motherOccup: { value: "", error: "" },
    motherEmployer: { value: "", error: "" },
    motherDepartment: { value: "", error: "" },
    motherMobile: { value: null, error: "", phoneCode: { value: "" } },
    motherWorkTel: { value: null, error: "", phoneCode: { value: "" } },
    motherEmail: { value: "", error: "" },
    motherExactJob: { value: "", error: "" },
  },
  emergency: [
    {
      name: { value: "", error: "" },
      contact: { value: "", error: "", phoneCode: { value: "" } },
      relationship: { value: "", error: "" },
      civilId: { value: "", error: "" }
    },
    {
      personTwo: { value: false, error: "" },
      name: { value: "", error: "" },
      contact: { value: "", error: "", phoneCode: { value: "" } },
      relationship: { value: "", error: "" },
      civilId: { value: "", error: "" }
    }
  ],

  school: {
    value: [
      {
        name: { value: "", error: "" },
        type: { value: "", error: "" },
        gpa: { value: "", error: "" },
        date: { value: "", error: "" },
        degree: { value: "", error: "" },
        physics: { value: "", error: "" },
        chemistry: { value: "", error: "" },
        biology: { value: "", error: "" },
        average: { value: "", error: "" }
      }
    ]
  },
  scientificMarks: {
    value: [
      {
        physics: { value: "", error: "" },
        chemistry: { value: "", error: "" },
        biology: { value: "", error: "" },
        average: { value: "", error: "" }
      }
    ]
  },
  isCollege: { value: true, error: "" },
  college: {
    value: [
      {
        name: { value: "", error: "" },
        type: { value: "", error: "" },
        country: { value: "", error: "", option: countryListOptions },
        gpa: { value: null, error: "" },
        date: { value: null, error: "" },
        major: { value: "", error: "" },
        degree: { value: "", error: "" }
      }
    ]
  },
  languages: [
    {
      language: { value: "English", error: "" },
      read: { value: "", error: "" },
      write: { value: "", error: "" },
      speak: { value: "", error: "" }
    },
    {
      language: { value: "Arabic", error: "" },
      read: { value: "", error: "" },
      write: { value: "", error: "" },
      speak: { value: "", error: "" }
    },
    {
      language: { value: "", error: "" },
      read: { value: "", error: "" },
      write: { value: "", error: "" },
      speak: { value: "", error: "" }
    }
  ],
  test: {
    testScore: { value: "", error: "" },
    testDate: { value: null, error: "" },
    testType: {
      value: "",
      error: "",
      option: [
        // { value: "NA", label: "NA" },
        { value: "IELTS", label: "IELTS" },
        { value: "toefl", label: "TOEFL" },
        { value: "other", label: "OTHER" }
      ]
    }
  },
  testTypeOtherNote: { value: "", error: "" },
  relatives: {
    value: [
      {
        name: "PUC",
        value: "puc"
      },
      {
        name: "MOHE",
        value: "mohe"
      },
      {
        name: "Kuwait University",
        value: "kuwait university"
      },
      {
        name: "None of the above",
        value: "na"
      }
    ],
    selected: { value: "" }
  },
  relativesNote: { value: "", error: "" },
  eligible: { value: null, error: "" },
  ministry: { value: false, error: "" },
};

export const testFormData = {
  firstName: { value: "John", error: "" },
  middleName: { value: "David", error: "" },
  lastName: { value: "Smith", error: "" },
  arabicFirstName: { value: "جون", error: "" },
  arabicMiddleName: { value: "ديفيد", error: "" },
  arabicLastName: { value: "سميث", error: "" },
  dob: { value: "2000-01-01", error: "" },
  gender: {
    value: "Male",
    option: [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" }
    ],
    error: ""
  },
  maritalStatus: {
    value: "single",
    option: [
      { value: "single", label: "Single" },
      { value: "married", label: "Married" },
      { value: "divorcee", label: "Divorcee" }
    ],
    error: ""
  },
  civilId: { value: "", error: "" },
  civilIdExpiryDate: { value: "2029-12-31", error: "" },
  mobileOne: { value: "99887766", error: "", phoneCode: { value: "965" } },
  mobileTwo: { value: "99887765", error: "", phoneCode: { value: "965" } },
  homeTelOne: { value: "22334455", error: "", phoneCode: { value: "965" } },
  homeTelTwo: { value: "22334456", error: "", phoneCode: { value: "965" } },
  workTel: { value: "22334457", error: "", phoneCode: { value: "965" } },
  faxTel: { value: "22334458", error: "", phoneCode: { value: "965" } },
  emailOne: { value: "test@example.com", error: "" },
  emailTwo: { value: "test2@example.com", error: "" },
  nationality: { value: "Non Kuwaiti", error: "", option: countryListOptions },
  birthCountry: { value: "Kuwait", error: "", option: countryListOptions },
  passport: { value: "Z12345678", error: "" },
  passportExpiry: { value: "2029-12-31", error: "" },
  securityCard: { value: "299010199999", error: "" },
  validityOfRes: { value: "2029-12-31", error: "" },
  securityCardExpiry: { value: "2029-12-31", error: "" },
  isHealthRecord: { value: false, error: "" },
  healthNote: { value: "", error: "" },
  isSuspended: { value: false, error: "" },
  suspensionNote: { value: "", error: "" },
  sponsorship: {
    value: { parents: true },
    error: ""
  },
  sponsorshipOtherNote: {
    value: "",
    error: ""
  },
  sponsorshipScholarshipNote: {
    value: "",
    error: ""
  },
  isDeclared: { value: true, error: "" },
  document: {
    photograph: { value: typeof File !== "undefined" ? new File([""], "photo.png", { type: "image/png" }) : null, error: "" },
    transcript: { value: typeof File !== "undefined" ? new File([""], "transcript.pdf", { type: "application/pdf" }) : null, error: "" },
    englishscore: { value: typeof File !== "undefined" ? new File([""], "english.pdf", { type: "application/pdf" }) : null, error: "" },
    highschool: { value: typeof File !== "undefined" ? new File([""], "highschool.pdf", { type: "application/pdf" }) : null, error: "" },
    civilidFront: { value: typeof File !== "undefined" ? new File([""], "civil_front.pdf", { type: "application/pdf" }) : null, error: "" },
    civilidBack: { value: typeof File !== "undefined" ? new File([""], "civil_back.pdf", { type: "application/pdf" }) : null, error: "" },
    securityCardFront: { value: typeof File !== "undefined" ? new File([""], "security_front.pdf", { type: "application/pdf" }) : null, error: "" },
    securityCardBack: { value: typeof File !== "undefined" ? new File([""], "security_back.pdf", { type: "application/pdf" }) : null, error: "" },
    passport: { value: typeof File !== "undefined" ? new File([""], "passport.pdf", { type: "application/pdf" }) : null, error: "" },
    record: { value: typeof File !== "undefined" ? new File([""], "record.pdf", { type: "application/pdf" }) : null, error: "" },
    goodconduct: { value: typeof File !== "undefined" ? new File([""], "goodconduct.pdf", { type: "application/pdf" }) : null, error: "" },
    fatherCivilId: { value: typeof File !== "undefined" ? new File([""], "father_civil.pdf", { type: "application/pdf" }) : null, error: "" },
    motherCivilId: { value: typeof File !== "undefined" ? new File([""], "mother_civil.pdf", { type: "application/pdf" }) : null, error: "" },
    sahel: { value: typeof File !== "undefined" ? new File([""], "sahel.pdf", { type: "application/pdf" }) : null, error: "" },
    equivalency: { value: typeof File !== "undefined" ? new File([""], "equivalency.pdf", { type: "application/pdf" }) : null, error: "" },
    birthCertificate: { value: typeof File !== "undefined" ? new File([""], "birth_cert.pdf", { type: "application/pdf" }) : null, error: "" },
    fatherPassport: { value: typeof File !== "undefined" ? new File([""], "father_passport.pdf", { type: "application/pdf" }) : null, error: "" },
    motherPassport: { value: typeof File !== "undefined" ? new File([""], "mother_passport.pdf", { type: "application/pdf" }) : null, error: "" },
    otherDocuments: { value: typeof File !== "undefined" ? new File([""], "other.pdf", { type: "application/pdf" }) : null, error: "" }
  },
  isAcademic: { value: false },
  archivements: { value: [{ value: "Science Award", error: "" }] },
  address: {
    home: { value: "Salmiya", error: "" },
    block: { value: "3", error: "" },
    appartment: { value: "12", error: "" },
    street: { value: "Amman Street", error: "" },
    area: { value: "Salmiya", error: "" },
    jaddah: {
      value: true,
      option: [
        { value: true, label: "True" },
        { value: false, label: "False" }
      ],
      error: ""
    },
    countryWithBedoon: {
      value: "Kuwait",
      error: "",
      option: countryListOptionWithBedoon
    },
    country: { value: "Kuwait", error: "", option: countryListOptions },
    po: { value: "12345", error: "" },
    zipCode: { value: "22003", error: "" },
    governorate: {
      value: "Hawalli Governorate",
      option: [
        { value: "Ahmadi Governorate", label: "Ahmadi Governorate" },
        { value: "Al-Asimah Governorate", label: "Al-Asimah Governorate" },
        { value: "Farwaniya Governorate", label: "Farwaniya Governorate" },
        { value: "Hawalli Governorate", label: "Hawalli Governorate" },
        { value: "Jahra Governorate", label: "Jahra Governorate" },
        {
          value: "Mubarak Al-Kabeer Governorate",
          label: "Mubarak Al-Kabeer Governorate"
        }
      ],
      error: ""
    }
  },
  family: {
    fatherName: { value: "Father Smith", error: "" },
    arabicFatherName: { value: "والد سميث", error: "" },
    fatherDob: { value: "1970-01-01", error: "" },
    fatherNationality: { value: "Kuwait", error: "", option: countryListOptions },
    fatherCivilId: { value: "270010199999", error: "" },
    fatherOccup: { value: "Engineer", error: "" },
    fatherEmployer: { value: "Ministry of Electricity", error: "" },
    fatherDepartment: { value: "Maintenance", error: "" },
    fatherMobile: { value: "99887755", error: "", phoneCode: { value: "965" } },
    fatherWorkTel: { value: "22334466", error: "", phoneCode: { value: "965" } },
    fatherEmail: { value: "father@example.com", error: "" },
    fatherExactJob: { value: "Senior Engineer", error: "" },
    motherName: { value: "Mother Smith", error: "" },
    arabicMotherName: { value: "والدة سميث", error: "" },
    motherDob: { value: "1975-01-01", error: "" },
    motherNationality: { value: "Kuwait", error: "", option: countryListOptions },
    motherCivilId: { value: "275010199999", error: "" },
    motherOccup: { value: "Teacher", error: "" },
    motherEmployer: { value: "Ministry of Education", error: "" },
    motherDepartment: { value: "High School", error: "" },
    motherMobile: { value: "99887744", error: "", phoneCode: { value: "965" } },
    motherWorkTel: { value: "22334477", error: "", phoneCode: { value: "965" } },
    motherEmail: { value: "mother@example.com", error: "" },
    motherExactJob: { value: "Biology Teacher", error: "" },
  },
  emergency: [
    {
      name: { value: "Emergency One", error: "" },
      contact: { value: "99887733", error: "", phoneCode: { value: "965" } },
      relationship: { value: "Uncle", error: "" },
      civilId: { value: "280010199999", error: "" }
    },
    {
      personTwo: { value: true, error: "" },
      name: { value: "Emergency Two", error: "" },
      contact: { value: "99887722", error: "", phoneCode: { value: "965" } },
      relationship: { value: "Aunt", error: "" },
      civilId: { value: "285010199999", error: "" }
    }
  ],
  school: {
    value: [
      {
        name: { value: "Kuwait National High School", error: "" },
        type: { value: "school", error: "" },
        gpa: { value: "3.9", error: "" },
        date: { value: "2018-06-01", error: "" },
        degree: { value: "High School Diploma", error: "" },
        physics: { value: "95", error: "" },
        chemistry: { value: "98", error: "" },
        biology: { value: "96", error: "" },
        average: { value: "96.3", error: "" }
      }
    ]
  },
  scientificMarks: {
    value: [
      {
        physics: { value: "95", error: "" },
        chemistry: { value: "98", error: "" },
        biology: { value: "96", error: "" },
        average: { value: "96.3", error: "" }
      }
    ]
  },
  isCollege: { value: false, error: "" },
  college: {
    value: [
      {
        name: { value: "", error: "" },
        type: { value: "", error: "" },
        country: { value: "", error: "", option: countryListOptions },
        gpa: { value: null, error: "" },
        date: { value: null, error: "" },
        major: { value: "", error: "" },
        degree: { value: "", error: "" }
      }
    ]
  },
  languages: [
    {
      language: { value: "English", error: "" },
      read: { value: "Excellent", error: "" },
      write: { value: "Excellent", error: "" },
      speak: { value: "Excellent", error: "" }
    },
    {
      language: { value: "Arabic", error: "" },
      read: { value: "Excellent", error: "" },
      write: { value: "Excellent", error: "" },
      speak: { value: "Excellent", error: "" }
    },
    {
      language: { value: "Spanish", error: "" },
      read: { value: "Good", error: "" },
      write: { value: "Good", error: "" },
      speak: { value: "Good", error: "" }
    }
  ],
  test: {
    testScore: { value: "7.5", error: "" },
    testDate: { value: "2025-01-01", error: "" },
    testType: {
      value: "IELTS",
      error: "",
      option: [
        { value: "IELTS", label: "IELTS" },
        { value: "toefl", label: "TOEFL" },
        { value: "other", label: "OTHER" }
      ]
    }
  },
  testTypeOtherNote: { value: "", error: "" },
  relatives: {
    value: [
      {
        name: "PUC",
        value: "puc"
      },
      {
        name: "MOHE",
        value: "mohe"
      },
      {
        name: "Kuwait University",
        value: "kuwait university"
      },
      {
        name: "None of the above",
        value: "na"
      }
    ],
    selected: { value: "na" }
  },
  relativesNote: { value: "", error: "" },
  eligible: { value: true, error: "" },
  ministry: { value: true, error: "" },
};

export const getTestFormData = () => {
  const randomCivilId = "2990101" + Math.floor(10000 + Math.random() * 90000);
  return {
    ...testFormData,
    civilId: { value: randomCivilId, error: "" }
  };
};

